import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            profitsLoading: false,
            ordersProfit: [],
            paymentProfit: [],
            profitFromDate: null,
            profitToDate: null,
            selectedProfitTab: 'orders',
            totalProfitPayments: 0,
            totalProfitOrders: 0,
            totalProfit: 0,
        }
    },
    methods: {
        formatMoney: formatMoney,
        chartWidth: chartWidth,
        shortLabel: shortLabel,
        loadProfits: loadProfits,
    },
    computed: {
        ordersProfitLines() {
            return (this.ordersProfit || []).map((x, idx) => ({
                id: x.id != null ? x.id : idx,
                name: x.name || '',
                image: x.image || x.imageMain || null,
                quantity: Number(x.quantity != null ? x.quantity : (x.qty != null ? x.qty : 0)),
                profit: Number(x.profit != null ? x.profit : 0),
            }));
        },
        paymentProfitLines() {
            return (this.paymentProfit || []).map((x, idx) => ({
                id: x.id != null ? x.id : idx,
                name: x.name || '',
                image: x.image || x.imageMain || null,
                quantity: Number(x.quantity != null ? x.quantity : (x.qty != null ? x.qty : 0)),
                profit: Number(x.profit != null ? x.profit : 0),
            }));
        },
        activeProfitLines() {
            return this.selectedProfitTab === 'payments'
                ? this.paymentProfitLines
                : this.ordersProfitLines;
        },
        activeTotalProfit() {
            return this.selectedProfitTab === 'payments'
                ? (this.totalProfitPayments || 0)
                : (this.totalProfitOrders || 0);
        },
        ordersProfitChartData() {
            return [...this.ordersProfitLines]
                .filter(i => Number(i.profit) > 0)
                .sort((a, b) => Number(b.profit) - Number(a.profit))
                .slice(0, 8);
        },
        paymentProfitChartData() {
            return [...this.paymentProfitLines]
                .filter(i => Number(i.profit) > 0)
                .sort((a, b) => Number(b.profit) - Number(a.profit))
                .slice(0, 8);
        },
        maxOrdersProfit() {
            if (!this.ordersProfitChartData.length) return 0;
            return Math.max(...this.ordersProfitChartData.map(i => Number(i.profit) || 0));
        },
        maxPaymentProfit() {
            if (!this.paymentProfitChartData.length) return 0;
            return Math.max(...this.paymentProfitChartData.map(i => Number(i.profit) || 0));
        },
        chartTotalOrders() {
            return this.ordersProfitChartData.reduce((sum, i) => sum + (Number(i.profit) || 0), 0);
        },
        chartTotalPayments() {
            return this.paymentProfitChartData.reduce((sum, i) => sum + (Number(i.profit) || 0), 0);
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.profitFromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.profitToDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.loadProfits();
    }
}

function formatMoney(value) {
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

function chartWidth(value, max) {
    const v = Number(value) || 0;
    const m = Number(max) || 0;
    if (m <= 0) return '0%';
    const ratio = (v / m) * 100;
    return `${Math.max(6, Math.min(100, ratio)).toFixed(2)}%`;
}

function shortLabel(value, maxLen = 24) {
    const txt = (value || '').toString().trim();
    if (txt.length <= maxLen) return txt;
    return `${txt.slice(0, maxLen - 1)}…`;
}

function loadProfits() {
    let _self = this
    _self.profitsLoading = true
    var model = {
        fromDate: _self.$moment(_self.profitFromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.profitToDate).format('DD-MM-YYYY'),
    }
    AdminApiService.getProfits(model)
        .then((response) => {
            _self.paymentProfit = response.data.paymentProfit;
            _self.ordersProfit = response.data.ordersProfit;
            _self.totalProfitPayments = response.data.totalProfitPayments;
            _self.totalProfitOrders = response.data.totalProfitOrders;
            _self.totalProfit = response.data.totalProfit;
            _self.profitsLoading = false
        })
        .catch(error => {
            _self.profitsLoading = false
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Report/profit.js